import SlideManager from "../utils/slide-manager";
import getVWKey from "../helpers/getVWKey";
import cloneObject from "../../editor/helpers/cloneObject";

const LimitManager = new class LimitManager {
    getObjectCameraLimits(slideIndex, objectUuid) {
        const slideData = SlideManager.getSlide(slideIndex);
        const slideLimits = this.getSlideLimits(slideIndex);

        if (!objectUuid || slideData.controls.interactionType !== "objectRotation")
            return slideLimits;

        const objectData = SlideManager.currentSlide.animation[objectUuid];

        if (!objectData) return slideLimits;

        return objectData.cameraLimits = getCameraData(objectData.cameraLimits) || cloneObject(slideLimits);
    }

    getSlideLimits(slideIndex) {
        const slideData = SlideManager.getSlide(slideIndex);
        const cameraLimits = slideData.cameraLimits;

        return getCameraData(cameraLimits);
    }
}

export default LimitManager;
export { LimitManager };

function getCameraData(cameraLimits) {
    const vpType = getVWKey();
    const cameraData = vpType === "sizeSm"
        ? cameraLimits[vpType] = cameraLimits[vpType] || JSON.parse(JSON.stringify(cameraLimits))
        : cameraLimits;

    return cameraData;
}